"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Tick = () => {
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: "24", height: "24", viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd", "stroke-linecap": "square" },
            react_1.default.createElement(react_native_svg_1.G, { stroke: "#090909" },
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, null,
                        react_1.default.createElement(react_native_svg_1.Path, { d: "M0.689 5.191L3.94 8.442 12.068 0.315", transform: "translate(-24 -502) translate(24 502) translate(5.835 8)" })))))));
};
exports.default = react_1.default.memo(Tick);
